const STATES = {
  CREATED: 'CREATED',
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  ASSIGNED: 'ASSIGNED',
  EDITED: 'EDITED',
  ACCEPTED: 'ACCEPTED',
  DONE: 'DONE',
  OUT_OF_SCOPE: 'OUT_OF_SCOPE',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  FEEDBACK_PROVIDED: 'FEEDBACK_PROVIDED',
  QUOTE_ADDED: 'QUOTE_ADDED',
  QUOTE_SENT: 'QUOTE_SENT',
  QUOTE_DETAILS_PROVIDED: 'QUOTE_DETAILS_PROVIDED',
  QUOTE_ACCEPTED: 'QUOTE_ACCEPTED',
  QUOTE_EXPIRED: 'QUOTE_EXPIRED',
  QUOTE_REJECTED: 'QUOTE_REJECTED',
  QUOTE_FEEDBACK_PROVIDED: 'QUOTE_FEEDBACK_PROVIDED',
  USER_INTEREST_REVALIDATED: 'USER_INTEREST_REVALIDATED',
};

export default STATES;
